export default "__VITE_ASSET__C9_nVEPK__"